import React, { useRef } from 'react';
import BottomSheet from '../../../Components/Ui/BottomSheet';
import { Box, Typography } from '@mui/material';
import { Button } from '../../../Components/MUIs';
import Icon from '../../../Assets/Icon/CustomIcon';
import { styled } from '@mui/material/styles';
import { Swiper, SwiperSlide } from 'swiper/react';
import { BottomSheetActions } from '../../../Reducer/BottomSheetReducer';
import { useDispatch } from 'react-redux';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

export default function SignWorkEndBottomSheet({
  SaveLogic1,
  previewList,
  FileChange,
  DeletePreview,
  setWorkEndInputs,
  workEndInputs,
}) {
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);

  const HandleSign = (e) => {
    SaveLogic1();
    dispatch(BottomSheetActions.CloseBottomSheet());
  };

  return (
    <BottomSheet
      isHeaderChildren={true}
      headerText={''}
      headerChildren={
        <Typography
          sx={{ fontSize: '18px', fontWeight: 'bold', display: 'flex' }}
        >
          개선 내용을 입력해주세요.
        </Typography>
      }
    >
      <Box sx={{ px: 1 }}>
        <Typography style={{ color: '#918A8A', paddingBottom: '0.5rem' }}>
          해당 내용은 기록됩니다.
        </Typography>

        <Typography
          sx={{
            fontSize: '16px',
            fontWeight: 'bold',
            display: 'flex',
          }}
        >
          개선 내용
        </Typography>
        <Box sx={{ display: 'flex', gap: 1, my: 2 }}>
          <Box>
            <button
              style={{
                cursor: 'pointer',
                border: '1px solid #DFD9D9',
                borderRadius: '8px',
                color: '#8D8787',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '14px',
                padding: '8px 16px',
                width: '90px',
                height: '92px',
              }}
              onClick={() => {
                fileInputRef.current?.click();
              }}
            >
              <Icon.Camera width={40} height={40} />
              <p>{previewList?.filter((img) => !img.deleted).length} / 5</p>
            </button>
            <VisuallyHiddenInput
              ref={fileInputRef}
              type="file"
              accept="image/*"
              onChange={FileChange}
            />
          </Box>

          {/* 썸네일 목록 */}
          <Box sx={{ flex: 1, width: '100%', overflow: 'hidden' }}>
            <Swiper slidesPerView="auto" spaceBetween={8}>
              {previewList
                ?.filter((img) => !img.deleted)
                ?.map((item, index) => (
                  <SwiperSlide className="workinfo-slide" key={index}>
                    <Box
                      sx={{
                        position: 'relative',
                        width: '90px',
                        height: '92px',
                        border: '1px solid #DFD9D9',
                        borderRadius: '8px',
                        overflow: 'hidden',
                      }}
                    >
                      <img
                        style={{
                          width: '100%',
                          objectFit: 'cover',
                        }}
                        src={item.preview}
                        alt="img"
                      />
                      <button
                        style={{
                          position: 'absolute',
                          top: 0,
                          right: 0,
                          border: 'none',
                          backgroundColor: 'transparent',
                          cursor: 'pointer',
                        }}
                        onClick={() => DeletePreview(item)}
                      >
                        <Icon.Delete width={20} height={20} />
                      </button>
                    </Box>
                  </SwiperSlide>
                ))}
            </Swiper>
          </Box>
        </Box>
        <textarea
          type="text"
          value={workEndInputs?.afterComment || ''}
          onChange={(e) =>
            setWorkEndInputs((prev) => ({
              ...prev,
              afterComment: e.target.value,
            }))
          }
          style={{
            width: '100%',
            padding: '14px 16px',
            borderRadius: '8px',
            outline: 'none',
            fontSize: '16px',
            backgroundColor: '#F8F8F8',
            border: 'none',
            transition: 'border-color 0.3s ease',
            minHeight: '10rem',
            resize: 'none',
            boxSizing: 'border-box',
          }}
          placeholder="개선 내용을 입력하세요"
        />
      </Box>
      <Box
        p={1}
        bgcolor="#fff"
        sx={{
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Button
          name="완료"
          sx={{
            width: '100%',
            height: 36,
            borderRadius: '5px',
            backgroundColor: '#57B84D',
            color: '#fff',
            boxShadow: 'none',
          }}
          onClick={HandleSign}
        />
      </Box>
    </BottomSheet>
  );
}
